import { Route, Routes } from "react-router-dom";
import { Routes as FleetDamageRoutes } from "./routes";
import { FleetDamageRouterCmp } from "./types";
import { DamageSearchPage } from "../pages/DamageSearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetDamageRouter: FleetDamageRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route
          path={DamageSearchPage.route}
          element={<DamageSearchPage />}
        />
      </Routes>
    </>
  );
};

FleetDamageRouter.route = FleetDamageRoutes.FleetDamageRouter;

export default FleetDamageRouter;
